<template>
  <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs-position" v-loading="loading">
    <el-tab-pane name="first">
      <span slot="label"><i class="el-icon-collection el-icon--left"></i>介绍</span>
      <div style="width: 1070px" >
        <div class="ql-container ql-snow" style="border: 0px">
          <div class="ql-editor">
            <div v-html="course.renderDesc"></div>
          </div>
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane name="second">
      <span slot="label"><i class="el-icon-document-copy el-icon--left"></i>目录</span>
      <!--章节-->
      <chapter :chapterDtos="course.chapterDtos"
               :course-id="course.id"
               :course-type="course.courseType === 'C'? 'edu':'train'"
               :userCourseProcess="course.userCourseProcess">
      </chapter>
    </el-tab-pane>
    <el-tab-pane name="third">
      <span slot="label"><i class="el-icon-chat-square el-icon--left"></i>评价</span>
      <comment :isHaveCourse="isHaveCourse" :commentArray="commentArray" :courseId="courseId" :pageInfo="pageInfo" @getPageListComment="getPageListComment"></comment>
    </el-tab-pane>
    <el-tab-pane name="fourth">
      <span slot="label"><i class="el-icon-chat-dot-round el-icon--left"></i>问答</span>
      <que-and-ans :qaArray="qaArray" :courseId="courseId" :pageInfo="pageInfo" @getPageListQA="getPageListQA"></que-and-ans>
    </el-tab-pane>
    <el-tab-pane name="fifth">
      <span slot="label"><i class="el-icon-download el-icon--left"></i>资料下载</span>
      <course-data-download :courseDataArray="courseDataArray" :courseId="courseId"></course-data-download>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import chapter from "@/components/course/chapter";
  const RecommendCourse = () => import('@/components/course/RecommendCourse');
  const Comment = () => import('@/components/course/Comment');
  const QueAndAns = () => import('@/components/course/QueAndAns');
  const CourseDataDownload = () => import('@/components/course/CourseDataDownload');
  export default {
    name: "CourseTab",
    components: {
      chapter,
      RecommendCourse,
      Comment,
      QueAndAns,
      CourseDataDownload
    },
    props: {
      courseId: '',
      course: null,
      isHaveCourse: ''
    },
    data() {
      return {
        commentArray: [], //课程评价
        qaArray: [], // 课程问答
        courseDataArray: [], // 课件
        activeName: 'second',
        pageInfo: {
          pageNum: 1,
          pageSize: 5,
          total: 0
        },
        loading: false,
      }
    },
    methods: {
      handleClick(tab, event) {
        if (this.activeName === 'third') {
          this.pageListComment(this.courseId,this.pageInfo.pageNum,this.pageInfo.pageSize,);
        } else if (this.activeName === 'fourth') {
          this.pageListQA(this.courseId,this.pageInfo.pageNum,this.pageInfo.pageSize,'');
        } else if (this.activeName === 'fifth') {
          this.listCourseData(this.courseId);
        }
      },
      async pageListComment(courseId,pageNum,pageSize) {
        this.loading = true;
        const {content} = await this.$http.post('/business/web/comment/pageList',{
          "courseId":courseId,
          "page": pageNum,
          "size": pageSize
        });
        this.commentArray = content.records;
        this.commentArray = this.commentArray.map(comment=>{
           comment.createdTime = comment.createdTime.substr(0,10);
           return comment;
        });
        this.pageInfo.pageNum = content.current;
        this.pageInfo.pageSize = content.size;
        this.pageInfo.total = content.total;
        this.loading = false;
      },
      async pageListQA(couseId,pageNum,pageSize,status) {
        this.loading = true;
        const {content} = await this.$http.post('/business/web/questionAnswer/pageList',{
          "courseId":couseId,
          "page": pageNum,
          "size": pageSize,
          "status": status
        });
        this.pageInfo.pageNum = content.current;
        this.pageInfo.pageSize = content.size;
        this.pageInfo.total = content.total;
        this.qaArray = content.records;
        this.qaArray = this.qaArray.map(qa=>{
          qa.createdTime = qa.createdTime.substr(0,10);
          return qa;
        });
        this.loading = false;
      },
      async listCourseData (courseId) {
        this.loading = true;
        const {content} =  await this.$http.get(`/business/web/courseData/list`,{
          params:{courseId:courseId}
        });
        this.courseDataArray = content;
        this.loading = false;
      },
      getPageListComment(data) {
        this.pageListComment(this.courseId,data.pageNum,data.pageSize)
      },
      getPageListQA(data) {
        this.pageListQA(this.courseId,data.pageNum,data.pageSize,data.status)
      }
    },
    mounted() {

    },
    created() {
    }
  }
</script>

<style scoped>
  /*tabs 的 相对位置*/
  .tabs-position {
    position: relative;
    top:-45px;
    left: 10px;
    width: 98%;
  }
  .el-tabs /deep/ .el-tabs__item {
    font-size: 16px;
    font-weight: 600;
  }
  .el-tabs >>> .el-tabs__nav-wrap::after {
    display: none;
  }
  .el-tabs >>> .el-tabs__nav-scroll {
    padding: 0 20px;
  }
  .el-tabs >>> .el-tabs__nav {
    padding-bottom: 5px;
  }

  i {
    font-size: 16px;
    font-weight: 600;
  }
</style>
